
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from "react-router-dom";
import logo from "./logo.png";
import logo2 from "./logo2.png";
import bgCircuit from "./background.png"; // Your uploaded background image

// sectionWrapper for the background
const SectionWrapper = ({ children }) => (
  <section
    className="flex flex-col items-center justify-center p-10 min-h-screen text-center bg-white/10 bg-opacity-10 bg-cover bg-center"
    style={{ backgroundImage: `url(${bgCircuit})` }}
  >
    {children}
  </section>
);

function BlogCard({ tag, title, desc, date, image }) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden flex flex-col text-left">
      <img src={image} alt={title} className="h-48 w-full object-cover" />
      <div className="p-4 flex flex-col justify-between flex-grow">
        <div className="flex justify-between items-center text-sm text-gray-400">
          <span className="text-green-600 font-semibold">{tag}</span>
          <span>{date}</span>
        </div>
        <h3 className="text-lg font-semibold text-dark dark:text-white mt-2">{title}</h3>
        <p className="text-gray-600 dark:text-gray-400 text-sm mb-3">{desc}</p>
        <span className="text-primary hover:underline text-sm font-semibold">READ MORE →</span>
      </div>
    </div>
  );
}

function Home() {
  const blogs = [
    {
      tag: "Articles",
      title: "The Role of Embedded Systems in Modern IoT",
      desc: "Embedded systems are the heartbeat of smart technology. Learn how they enable automation, energy efficiency, and connectivity across industries.",
      date: "15/10/2024",
      image: "/embedded_systems_iot.png",
    },
    {
      tag: "Case Study",
      title: "Energy Monitoring for Smart Grids",
      desc: "How ROEmbedded delivered a low-power energy data logger with MQTT for live smart grid monitoring.",
      date: "03/12/2024",
      image: "/energy_monitoring_smart_grids.png",
    },
    {
      tag: "Articles",
      title: "Secure Bootloaders for Microcontrollers",
      desc: "A guide to implementing secure OTA firmware updates in STM32, RP2040, and ESP32 devices.",
      date: "04/11/2024",
      image: "/secure_bootloaders.png",
    },
  ];

  return (
    <SectionWrapper>
      <div className="flex flex-col md:flex-row items-center justify-center gap-10 mb-12 max-w-6xl w-full">
        <img src={logo} alt="ROEmbedded Logo" className="w-32 sm:w-40 md:w-48 h-auto" />
        <div className="text-left">
          <h1 className="text-3xl md:text-4xl font-bold text-primary dark:text-white mb-2">Welcome to ROEmbedded</h1>
          <p className="text-dark dark:text-gray-300 max-w-xl">We build cutting-edge embedded and IoT solutions tailored for the future.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl w-full">
        {blogs.map((item, index) => (
          <BlogCard key={index} {...item} />
        ))}
      </div>
    </SectionWrapper>
  );
}

function About() {
  return (
    <section className="flex flex-col items-center justify-center p-10 bg-background min-h-screen text-center">
      <h2 className="text-3xl font-semibold text-primary mb-4">ABOUT US</h2>
      <p className="text-dark max-w-xl">ROEmbedded is a specialist in embedded systems, IoT, and automation projects, offering a range of services from firmware to full-stack IoT deployments.</p>

      <div className="max-w-3xl w-full text-center bg-white/70 dark:bg-gray-800/70 rounded-lg shadow p-6">
        <h3 className="text-2xl font-semibold text-primary dark:text-white mb-4">FOUNDER’s PROFILE</h3>
        <iframe
          src="https://rashidobaid.github.io/"
          title="Founder Profile"
          className="w-full h-[600px] rounded-lg border dark:border-gray-700"
        ></iframe>
      </div>
    </section>
  );
}

function Services() {
  return (
    <SectionWrapper>      
      <h2 className="text-3xl font-semibold text-primary mb-4">Services</h2>
      <ul className="text-dark list-disc pl-5 text-left max-w-md">
        <li>Embedded Systems Design</li>
        <li>Firmware Development</li>
        <li>PCB Prototyping</li>
        <li>IoT Integration</li>
        <li>Cloud Monitoring (DigitalOcean)</li>
        <li>Custom PLC+HMI solutions</li>
      </ul>
    </SectionWrapper>
  );
}

function Projects() {
  return (
    <section className="flex flex-col items-center justify-center p-10 bg-background min-h-screen text-center">
      <h2 className="text-3xl font-semibold text-primary mb-4">Projects</h2>
      <p className="text-dark max-w-xl">Coming soon: A showcase of real-world embedded and automation solutions.</p>
    </section>
  );
}

function Contact() {
  return (
    <SectionWrapper>
      <h2 className="text-3xl font-semibold text-primary mb-4">Contact</h2>
      <form className="max-w-md w-full space-y-4 text-left">
        <input type="text" placeholder="Name" className="w-full p-2 border rounded" />
        <input type="email" placeholder="Email" className="w-full p-2 border rounded" />
        <textarea placeholder="Message" className="w-full p-2 border rounded"></textarea>
        <button className="bg-primary text-white px-4 py-2 rounded hover:bg-secondary">Send</button>
      </form>
      <p className="text-dark mt-4">Or reach out via <a href="https://www.linkedin.com/in/rashidobaid/" className="text-primary underline">LinkedIn</a>.</p>
    </SectionWrapper>
  );
}

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-dark text-white p-4 flex flex-col sm:flex-row justify-between items-center text-center">
      <div className="flex items-center justify-between w-full sm:w-auto">
        <div className="flex items-center space-x-2">
          <img src={logo2} alt="Logo" className="w-10 h-10" />
          <span className="font-bold text-lg">ROEmbedded</span>
        </div>
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="sm:hidden focus:outline-none text-white"
        >
          ☰
        </button>
      </div>
      <div className={`${menuOpen ? "block" : "hidden"} sm:flex sm:space-x-4 w-full sm:w-auto mt-2 sm:mt-0`}>        
        <Link to="/" className="block py-1 hover:text-secondary">Home</Link>
        <Link to="/about" className="block py-1 hover:text-secondary">About</Link>
        <Link to="/services" className="block py-1 hover:text-secondary">Services</Link>
        <Link to="/projects" className="block py-1 hover:text-secondary">Projects</Link>
        <Link to="/contact" className="block py-1 hover:text-secondary">Contact</Link>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="bg-dark text-white text-sm text-center py-4 mt-10">
      <p>© {new Date().getFullYear()} ROEmbedded. All rights reserved.</p>
    </footer>
  );
}

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}


